var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useCallback, useEffect } from 'react';
import { useBoolean } from 'react-use';
import { useDinPlayerContext } from './useDinPlayerContext';
export function usePreviewLoop(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.autoPlay, autoPlay = _c === void 0 ? true : _c, _d = _b.config, config = _d === void 0 ? {} : _d;
    var dinPlayer = useDinPlayerContext();
    var state = dinPlayer.state, playTriplet = dinPlayer.playTriplet, stop = dinPlayer.stop;
    var _e = useBoolean(false), paused = _e[0], togglePaused = _e[1];
    var triggerPreview = useCallback(function () {
        if (paused)
            return;
        playTriplet([4, 5, 6], __assign({ noNoise: true }, config));
    }, [paused]);
    useEffect(function () {
        triggerPreview();
        var interval = setInterval(function () {
            triggerPreview();
        }, 4000);
        return function () {
            stop();
            clearInterval(interval);
        };
    }, [paused]);
    return {
        dinPlayer: dinPlayer,
        paused: paused,
        togglePaused: togglePaused,
    };
}
export default usePreviewLoop;
